import styled from 'styled-components';

const Division = styled.hr<{ $margin?: string }>`
  margin: ${(p) => p.$margin ?? '4px 0'};
  ${(p) => p.theme.border.gray};
  border-top: 0;
`;

export default Division;
